export default __webpack_public_path__ + "static/media/hand.c62b1afb.jpg";